import { render, staticRenderFns } from "./pwa-install-dialog.vue?vue&type=template&id=6c263b77&"
import script from "./pwa-install-dialog.vue?vue&type=script&lang=js&"
export * from "./pwa-install-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports